import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { t } from 'Src/i18n';
import { Title } from 'Components/frameworks/title/Title';
import { AvailabilityBadge } from 'Components/widgets/availability-badge/AvailabilityBadge';
type Props = {
  children?: string;
  className?: string;
  id?: string;
  isOnDemand?: boolean;
};
export const RentalsSectionTitle = ({ children, className, id, isOnDemand = false }: Props) => (
  <Title
    className={classnames('justify-between border-b-1 border-lightGrey', className)}
    hLevel={3}
    id={id}
    theme="title-brand-n1"
  >
    {children}
    <span className="inline-flex shrink-0 items-center gap-5 font-sans text-14 leading-1 text-black">
      <AvailabilityBadge isOnDemand={isOnDemand} />
      {t(isOnDemand ? 'common.onDemand' : 'common.included')}
    </span>
  </Title>
);
